export const SCENE_ANIMATION_4 = {
    "items": [
        {
            "time": 0.019999999552965165,
            "data": [
                "prisoner,4.024,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.790,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.024,-0.873,0.050,0.485"
            ]
        },
        {
            "time": 0.029999999329447748,
            "data": [
                "prisoner,4.024,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.790,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.024,-0.873,0.050,0.485"
            ]
        },
        {
            "time": 0.07500000298023224,
            "data": [
                "prisoner,4.025,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.781,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.024,-0.873,0.050,0.485"
            ]
        },
        {
            "time": 0.10000000149011612,
            "data": [
                "prisoner,4.031,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.741,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.024,-0.876,0.050,0.480"
            ]
        },
        {
            "time": 0.1120000034570694,
            "data": [
                "prisoner,4.037,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.719,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.024,-0.878,0.050,0.475"
            ]
        },
        {
            "time": 0.11699999868869782,
            "data": [
                "prisoner,4.040,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.708,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.024,-0.879,0.051,0.473"
            ]
        },
        {
            "time": 0.13099999725818635,
            "data": [
                "prisoner,4.042,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.704,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.024,-0.880,0.051,0.472"
            ]
        },
        {
            "time": 0.1509999930858612,
            "data": [
                "prisoner,4.046,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.692,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.024,-0.882,0.051,0.468"
            ]
        },
        {
            "time": 0.16899999976158143,
            "data": [
                "prisoner,4.053,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.674,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.024,-0.885,0.051,0.463"
            ]
        },
        {
            "time": 0.18199999630451203,
            "data": [
                "prisoner,4.060,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.657,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.024,-0.887,0.052,0.458"
            ]
        },
        {
            "time": 0.1979999989271164,
            "data": [
                "prisoner,4.065,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.645,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.023,-0.890,0.052,0.453"
            ]
        },
        {
            "time": 0.210999995470047,
            "data": [
                "prisoner,4.072,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.632,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.023,-0.892,0.052,0.448"
            ]
        },
        {
            "time": 0.22499999403953553,
            "data": [
                "prisoner,4.078,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.620,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.023,-0.895,0.053,0.443"
            ]
        },
        {
            "time": 0.23999999463558198,
            "data": [
                "prisoner,4.085,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.607,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.023,-0.897,0.053,0.438"
            ]
        },
        {
            "time": 0.25699999928474429,
            "data": [
                "prisoner,4.092,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.594,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.023,-0.900,0.054,0.432"
            ]
        },
        {
            "time": 0.2720000147819519,
            "data": [
                "prisoner,4.102,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.579,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.023,-0.903,0.054,0.425"
            ]
        },
        {
            "time": 0.28299999237060549,
            "data": [
                "prisoner,4.110,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.565,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.022,-0.906,0.055,0.418"
            ]
        },
        {
            "time": 0.2980000078678131,
            "data": [
                "prisoner,4.116,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.555,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.022,-0.909,0.055,0.413"
            ]
        },
        {
            "time": 0.31200000643730166,
            "data": [
                "prisoner,4.125,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.542,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.022,-0.912,0.056,0.406"
            ]
        },
        {
            "time": 0.32600000500679018,
            "data": [
                "prisoner,4.134,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.530,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.022,-0.915,0.056,0.399"
            ]
        },
        {
            "time": 0.34200000762939455,
            "data": [
                "prisoner,4.142,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.517,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.021,-0.918,0.057,0.392"
            ]
        },
        {
            "time": 0.36000001430511477,
            "data": [
                "prisoner,4.152,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.503,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.021,-0.921,0.057,0.384"
            ]
        },
        {
            "time": 0.37400001287460329,
            "data": [
                "prisoner,4.164,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.487,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.021,-0.925,0.058,0.375"
            ]
        },
        {
            "time": 0.3869999945163727,
            "data": [
                "prisoner,4.173,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.474,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.020,-0.928,0.059,0.367"
            ]
        },
        {
            "time": 0.4020000100135803,
            "data": [
                "prisoner,4.182,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.463,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.020,-0.931,0.059,0.360"
            ]
        },
        {
            "time": 0.41600000858306887,
            "data": [
                "prisoner,4.192,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.450,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.020,-0.934,0.060,0.352"
            ]
        },
        {
            "time": 0.4309999942779541,
            "data": [
                "prisoner,4.202,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.437,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.019,-0.937,0.060,0.343"
            ]
        },
        {
            "time": 0.44600000977516177,
            "data": [
                "prisoner,4.212,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.424,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.019,-0.940,0.061,0.335"
            ]
        },
        {
            "time": 0.46299999952316286,
            "data": [
                "prisoner,4.222,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.411,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.018,-0.943,0.062,0.327"
            ]
        },
        {
            "time": 0.47699999809265139,
            "data": [
                "prisoner,4.234,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.395,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.018,-0.946,0.062,0.317"
            ]
        },
        {
            "time": 0.48899999260902407,
            "data": [
                "prisoner,4.245,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.382,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.018,-0.949,0.063,0.308"
            ]
        },
        {
            "time": 0.5040000081062317,
            "data": [
                "prisoner,4.253,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.372,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.017,-0.951,0.063,0.301"
            ]
        },
        {
            "time": 0.5180000066757202,
            "data": [
                "prisoner,4.263,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.359,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.017,-0.954,0.064,0.292"
            ]
        },
        {
            "time": 0.5320000052452087,
            "data": [
                "prisoner,4.274,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.346,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.016,-0.957,0.065,0.284"
            ]
        },
        {
            "time": 0.546999990940094,
            "data": [
                "prisoner,4.284,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.333,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.016,-0.959,0.065,0.275"
            ]
        },
        {
            "time": 0.5659999847412109,
            "data": [
                "prisoner,4.294,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.320,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.015,-0.962,0.066,0.266"
            ]
        },
        {
            "time": 0.5820000171661377,
            "data": [
                "prisoner,4.307,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.303,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.015,-0.964,0.067,0.255"
            ]
        },
        {
            "time": 0.5950000286102295,
            "data": [
                "prisoner,4.318,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.289,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.014,-0.967,0.067,0.246"
            ]
        },
        {
            "time": 0.6100000143051148,
            "data": [
                "prisoner,4.327,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.278,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.014,-0.969,0.068,0.238"
            ]
        },
        {
            "time": 0.625,
            "data": [
                "prisoner,4.338,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.264,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.013,-0.971,0.068,0.230"
            ]
        },
        {
            "time": 0.6389999985694885,
            "data": [
                "prisoner,4.348,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.251,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.013,-0.973,0.069,0.221"
            ]
        },
        {
            "time": 0.6539999842643738,
            "data": [
                "prisoner,4.358,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.238,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.012,-0.975,0.069,0.213"
            ]
        },
        {
            "time": 0.6710000038146973,
            "data": [
                "prisoner,4.367,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.225,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.012,-0.976,0.070,0.205"
            ]
        },
        {
            "time": 0.6859999895095825,
            "data": [
                "prisoner,4.378,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.210,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.011,-0.978,0.070,0.195"
            ]
        },
        {
            "time": 0.6980000138282776,
            "data": [
                "prisoner,4.387,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.196,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.011,-0.980,0.071,0.187"
            ]
        },
        {
            "time": 0.7129999995231628,
            "data": [
                "prisoner,4.394,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.185,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.010,-0.981,0.071,0.181"
            ]
        },
        {
            "time": 0.7269999980926514,
            "data": [
                "prisoner,4.403,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.172,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.010,-0.982,0.072,0.173"
            ]
        },
        {
            "time": 0.7419999837875366,
            "data": [
                "prisoner,4.411,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.159,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.009,-0.983,0.072,0.166"
            ]
        },
        {
            "time": 0.7549999952316284,
            "data": [
                "prisoner,4.419,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.147,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.009,-0.985,0.073,0.159"
            ]
        },
        {
            "time": 0.7739999890327454,
            "data": [
                "prisoner,4.427,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.134,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.009,-0.985,0.073,0.153"
            ]
        },
        {
            "time": 0.7870000004768372,
            "data": [
                "prisoner,4.436,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.117,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.008,-0.987,0.074,0.145"
            ]
        },
        {
            "time": 0.796999990940094,
            "data": [
                "prisoner,4.443,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.106,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.008,-0.987,0.074,0.139"
            ]
        },
        {
            "time": 0.8109999895095825,
            "data": [
                "prisoner,4.448,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.097,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.007,-0.988,0.074,0.135"
            ]
        },
        {
            "time": 0.8259999752044678,
            "data": [
                "prisoner,4.454,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.084,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.007,-0.989,0.074,0.130"
            ]
        },
        {
            "time": 0.8389999866485596,
            "data": [
                "prisoner,4.460,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.071,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.007,-0.989,0.075,0.124"
            ]
        },
        {
            "time": 0.8529999852180481,
            "data": [
                "prisoner,4.465,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.059,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.006,-0.990,0.075,0.120"
            ]
        },
        {
            "time": 0.8669999837875366,
            "data": [
                "prisoner,4.470,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.047,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.006,-0.990,0.075,0.115"
            ]
        },
        {
            "time": 0.8830000162124634,
            "data": [
                "prisoner,4.475,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.035,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.006,-0.991,0.076,0.111"
            ]
        },
        {
            "time": 0.8970000147819519,
            "data": [
                "prisoner,4.480,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.020,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.991,0.076,0.107"
            ]
        },
        {
            "time": 0.9079999923706055,
            "data": [
                "prisoner,4.484,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,10.008,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.992,0.076,0.103"
            ]
        },
        {
            "time": 0.921999990940094,
            "data": [
                "prisoner,4.487,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,9.998,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.992,0.076,0.101"
            ]
        },
        {
            "time": 0.9350000023841858,
            "data": [
                "prisoner,4.490,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,9.986,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.992,0.076,0.098"
            ]
        },
        {
            "time": 0.9490000009536743,
            "data": [
                "prisoner,4.492,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,9.974,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.992,0.076,0.096"
            ]
        },
        {
            "time": 0.9629999995231628,
            "data": [
                "prisoner,4.494,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,9.962,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.076,0.094"
            ]
        },
        {
            "time": 0.9769999980926514,
            "data": [
                "prisoner,4.496,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,9.949,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.093"
            ]
        },
        {
            "time": 0.9929999709129334,
            "data": [
                "prisoner,4.497,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,9.937,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.092"
            ]
        },
        {
            "time": 1.0089999437332154,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.707,0.000,0.707",
                "police3,9.922,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.0180000066757203,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.707,0.000,0.708",
                "police3,9.909,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.031999945640564,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.705,0.000,0.709",
                "police3,9.900,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.0449999570846558,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.701,0.000,0.713",
                "police3,9.888,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.059000015258789,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.694,0.000,0.720",
                "police3,9.876,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.0740000009536744,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.685,0.000,0.728",
                "police3,9.863,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.0859999656677247,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.674,0.000,0.739",
                "police3,9.850,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.1030000448226929,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.662,0.000,0.750",
                "police3,9.839,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.1180000305175782,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.643,0.000,0.766",
                "police3,9.824,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.128999948501587,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.624,0.000,0.781",
                "police3,9.811,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.1419999599456788,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.610,0.000,0.793",
                "police3,9.801,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.156000018119812,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.590,0.000,0.807",
                "police3,9.790,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.1699999570846558,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.568,0.000,0.823",
                "police3,9.777,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.1829999685287476,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.544,0.000,0.839",
                "police3,9.765,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.1970000267028809,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.519,0.000,0.855",
                "police3,9.753,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.2130000591278077,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.493,0.000,0.870",
                "police3,9.741,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.2259999513626099,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.461,0.000,0.888",
                "police3,9.726,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.2389999628067017,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.433,0.000,0.901",
                "police3,9.714,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.253000020980835,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.406,0.000,0.914",
                "police3,9.703,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.2660000324249268,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.376,0.000,0.927",
                "police3,9.691,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.2799999713897706,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.348,0.000,0.937",
                "police3,9.679,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.2949999570846558,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.318,0.000,0.948",
                "police3,9.667,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.3079999685287476,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.285,0.000,0.959",
                "police3,9.653,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.3259999752044678,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.256,0.000,0.967",
                "police3,9.642,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.340000033378601,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.218,0.000,0.976",
                "police3,9.626,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.3489999771118165,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.189,0.000,0.982",
                "police3,9.613,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.3619999885559083,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.171,0.000,0.985",
                "police3,9.605,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.3760000467300416,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.145,0.000,0.989",
                "police3,9.593,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.3899999856948853,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.120,0.000,0.993",
                "police3,9.581,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.4040000438690186,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.097,0.000,0.995",
                "police3,9.568,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.4179999828338624,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.075,0.000,0.997",
                "police3,9.556,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.4359999895095826,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.056,0.000,0.998",
                "police3,9.543,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.4509999752044678,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.036,0.000,0.999",
                "police3,9.528,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.4600000381469727,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.021,0.000,1.000",
                "police3,9.514,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.4730000495910645,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.014,0.000,1.000",
                "police3,9.506,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.4869999885559083,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.006,0.000,1.000",
                "police3,9.494,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.5019999742507935,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.002,0.000,1.000",
                "police3,9.482,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.5160000324249268,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.000,0.000,1.000",
                "police3,9.468,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.5290000438690186,
            "data": [
                "prisoner,4.498,0.000,1.262,0.000,0.000,0.000,1.000",
                "police3,9.456,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.091"
            ]
        },
        {
            "time": 1.5470000505447388,
            "data": [
                "prisoner,4.498,0.000,1.263,0.000,0.000,0.000,1.000",
                "police3,9.445,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.092"
            ]
        },
        {
            "time": 1.559000015258789,
            "data": [
                "prisoner,4.498,0.000,1.263,0.000,0.000,0.000,1.000",
                "police3,9.428,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.093"
            ]
        },
        {
            "time": 1.5700000524520875,
            "data": [
                "prisoner,4.498,0.000,1.264,0.000,0.000,0.000,1.000",
                "police3,9.417,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.004,-0.993,0.077,0.094"
            ]
        },
        {
            "time": 1.5839999914169312,
            "data": [
                "prisoner,4.498,0.000,1.265,0.000,0.000,0.000,1.000",
                "police3,9.408,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.993,0.077,0.095"
            ]
        },
        {
            "time": 1.5989999771118165,
            "data": [
                "prisoner,4.498,0.000,1.267,0.000,0.000,0.000,1.000",
                "police3,9.396,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.992,0.076,0.096"
            ]
        },
        {
            "time": 1.6109999418258668,
            "data": [
                "prisoner,4.498,0.000,1.268,0.000,0.000,0.000,1.000",
                "police3,9.382,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.992,0.076,0.098"
            ]
        },
        {
            "time": 1.6260000467300416,
            "data": [
                "prisoner,4.498,0.000,1.270,0.000,0.000,0.000,1.000",
                "police3,9.371,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.992,0.076,0.100"
            ]
        },
        {
            "time": 1.6390000581741334,
            "data": [
                "prisoner,4.498,0.000,1.272,0.000,0.000,0.000,1.000",
                "police3,9.358,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.992,0.076,0.102"
            ]
        },
        {
            "time": 1.6549999713897706,
            "data": [
                "prisoner,4.498,0.000,1.274,0.000,0.000,0.000,1.000",
                "police3,9.347,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.992,0.076,0.104"
            ]
        },
        {
            "time": 1.6679999828338624,
            "data": [
                "prisoner,4.498,0.000,1.277,0.000,0.000,0.000,1.000",
                "police3,9.332,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.005,-0.991,0.076,0.107"
            ]
        },
        {
            "time": 1.6799999475479127,
            "data": [
                "prisoner,4.498,0.000,1.280,0.000,0.000,0.000,1.000",
                "police3,9.320,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.006,-0.991,0.076,0.110"
            ]
        },
        {
            "time": 1.694000005722046,
            "data": [
                "prisoner,4.498,0.000,1.282,0.000,0.000,0.000,1.000",
                "police3,9.310,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.006,-0.991,0.076,0.113"
            ]
        },
        {
            "time": 1.7079999446868897,
            "data": [
                "prisoner,4.498,0.000,1.285,0.000,0.000,0.000,1.000",
                "police3,9.297,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.006,-0.990,0.076,0.116"
            ]
        },
        {
            "time": 1.722000002861023,
            "data": [
                "prisoner,4.498,0.000,1.289,0.000,0.000,0.000,1.000",
                "police3,9.285,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.006,-0.990,0.076,0.120"
            ]
        },
        {
            "time": 1.7350000143051148,
            "data": [
                "prisoner,4.498,0.000,1.292,0.000,0.000,0.000,1.000",
                "police3,9.272,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.007,-0.989,0.076,0.124"
            ]
        },
        {
            "time": 1.75,
            "data": [
                "prisoner,4.498,0.000,1.296,0.000,0.000,0.000,1.000",
                "police3,9.261,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.007,-0.989,0.075,0.127"
            ]
        },
        {
            "time": 1.7649999856948853,
            "data": [
                "prisoner,4.498,0.000,1.300,0.000,0.000,0.000,1.000",
                "police3,9.247,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.007,-0.988,0.075,0.132"
            ]
        },
        {
            "time": 1.7799999713897706,
            "data": [
                "prisoner,4.498,0.000,1.304,0.000,0.000,0.000,1.000",
                "police3,9.234,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.008,-0.988,0.075,0.136"
            ]
        },
        {
            "time": 1.7910000085830689,
            "data": [
                "prisoner,4.498,0.000,1.309,0.000,0.000,0.000,1.000",
                "police3,9.221,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.008,-0.987,0.075,0.141"
            ]
        },
        {
            "time": 1.8049999475479127,
            "data": [
                "prisoner,4.498,0.000,1.312,0.000,0.000,0.000,1.000",
                "police3,9.211,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.008,-0.987,0.075,0.145"
            ]
        },
        {
            "time": 1.8200000524520875,
            "data": [
                "prisoner,4.498,0.000,1.317,0.000,0.000,0.000,1.000",
                "police3,9.199,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.009,-0.986,0.075,0.150"
            ]
        },
        {
            "time": 1.8339999914169312,
            "data": [
                "prisoner,4.498,0.000,1.322,0.000,0.000,0.000,1.000",
                "police3,9.185,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.009,-0.985,0.074,0.155"
            ]
        },
        {
            "time": 1.847000002861023,
            "data": [
                "prisoner,4.498,0.000,1.327,0.000,0.000,0.000,1.000",
                "police3,9.172,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.009,-0.984,0.074,0.161"
            ]
        },
        {
            "time": 1.8600000143051148,
            "data": [
                "prisoner,4.498,0.000,1.331,0.000,0.000,0.000,1.000",
                "police3,9.161,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.010,-0.983,0.074,0.165"
            ]
        },
        {
            "time": 1.8760000467300416,
            "data": [
                "prisoner,4.498,0.000,1.336,0.000,0.000,0.000,1.000",
                "police3,9.149,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.010,-0.983,0.074,0.171"
            ]
        },
        {
            "time": 1.8919999599456788,
            "data": [
                "prisoner,4.498,0.000,1.342,0.000,0.000,0.000,1.000",
                "police3,9.135,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.010,-0.981,0.073,0.177"
            ]
        },
        {
            "time": 1.9019999504089356,
            "data": [
                "prisoner,4.498,0.000,1.348,0.000,0.000,0.000,1.000",
                "police3,9.121,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.011,-0.980,0.073,0.184"
            ]
        },
        {
            "time": 1.9170000553131104,
            "data": [
                "prisoner,4.498,0.000,1.352,0.000,0.000,0.000,1.000",
                "police3,9.112,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.011,-0.979,0.073,0.188"
            ]
        },
        {
            "time": 1.9329999685287476,
            "data": [
                "prisoner,4.498,0.000,1.358,0.000,0.000,0.000,1.000",
                "police3,9.099,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.012,-0.978,0.073,0.194"
            ]
        },
        {
            "time": 1.9470000267028809,
            "data": [
                "prisoner,4.498,0.000,1.365,0.000,0.000,0.000,1.000",
                "police3,9.084,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.012,-0.977,0.073,0.201"
            ]
        },
        {
            "time": 1.9600000381469727,
            "data": [
                "prisoner,4.498,0.000,1.371,0.000,0.000,0.000,1.000",
                "police3,9.072,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.013,-0.975,0.072,0.208"
            ]
        },
        {
            "time": 1.9759999513626099,
            "data": [
                "prisoner,4.498,0.000,1.376,0.000,0.000,0.000,1.000",
                "police3,9.060,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.013,-0.974,0.072,0.213"
            ]
        },
        {
            "time": 1.9910000562667847,
            "data": [
                "prisoner,4.498,0.000,1.383,0.000,0.000,0.000,1.000",
                "police3,9.046,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.936,0.013,-0.973,0.072,0.221"
            ]
        },
        {
            "time": 2.005000114440918,
            "data": [
                "prisoner,4.498,0.000,1.390,0.000,0.000,0.000,1.000",
                "police3,9.032,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.014,-0.971,0.071,0.228"
            ]
        },
        {
            "time": 2.0199999809265138,
            "data": [
                "prisoner,4.498,0.000,1.396,0.000,0.000,0.000,1.000",
                "police3,9.020,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.014,-0.969,0.071,0.235"
            ]
        },
        {
            "time": 2.0339999198913576,
            "data": [
                "prisoner,4.498,0.000,1.403,0.000,0.000,0.000,1.000",
                "police3,9.007,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.015,-0.968,0.071,0.242"
            ]
        },
        {
            "time": 2.0490000247955324,
            "data": [
                "prisoner,4.498,0.000,1.410,0.000,0.000,0.000,1.000",
                "police3,8.994,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.015,-0.966,0.070,0.249"
            ]
        },
        {
            "time": 2.062999963760376,
            "data": [
                "prisoner,4.498,0.000,1.417,0.000,0.000,0.000,1.000",
                "police3,8.980,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.016,-0.964,0.070,0.257"
            ]
        },
        {
            "time": 2.0769999027252199,
            "data": [
                "prisoner,4.498,0.000,1.424,0.000,0.000,0.000,1.000",
                "police3,8.968,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.016,-0.962,0.070,0.263"
            ]
        },
        {
            "time": 2.0950000286102297,
            "data": [
                "prisoner,4.498,0.000,1.431,0.000,0.000,0.000,1.000",
                "police3,8.955,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.017,-0.960,0.069,0.270"
            ]
        },
        {
            "time": 2.109999895095825,
            "data": [
                "prisoner,4.498,0.000,1.439,0.000,0.000,0.000,1.000",
                "police3,8.940,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.017,-0.958,0.069,0.279"
            ]
        },
        {
            "time": 2.122999906539917,
            "data": [
                "prisoner,4.498,0.000,1.446,0.000,0.000,0.000,1.000",
                "police3,8.927,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.018,-0.955,0.069,0.287"
            ]
        },
        {
            "time": 2.140000104904175,
            "data": [
                "prisoner,4.498,0.000,1.453,0.000,0.000,0.000,1.000",
                "police3,8.915,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.018,-0.953,0.068,0.294"
            ]
        },
        {
            "time": 2.1540000438690187,
            "data": [
                "prisoner,4.498,0.000,1.461,0.000,0.000,0.000,1.000",
                "police3,8.899,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.019,-0.951,0.068,0.303"
            ]
        },
        {
            "time": 2.1710000038146974,
            "data": [
                "prisoner,4.498,0.000,1.468,0.000,0.000,0.000,1.000",
                "police3,8.887,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.019,-0.948,0.068,0.310"
            ]
        },
        {
            "time": 2.184999942779541,
            "data": [
                "prisoner,4.498,0.000,1.477,0.000,0.000,0.000,1.000",
                "police3,8.872,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.020,-0.945,0.067,0.319"
            ]
        },
        {
            "time": 2.2039999961853029,
            "data": [
                "prisoner,4.498,0.000,1.484,0.000,0.000,0.000,1.000",
                "police3,8.859,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.020,-0.943,0.067,0.326"
            ]
        },
        {
            "time": 2.2230000495910646,
            "data": [
                "prisoner,4.498,0.000,1.493,0.000,0.000,0.000,1.000",
                "police3,8.843,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.021,-0.940,0.066,0.335"
            ]
        },
        {
            "time": 2.2330000400543215,
            "data": [
                "prisoner,4.498,0.000,1.503,0.000,0.000,0.000,1.000",
                "police3,8.826,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.021,-0.936,0.066,0.345"
            ]
        },
        {
            "time": 2.250999927520752,
            "data": [
                "prisoner,4.498,0.000,1.508,0.000,0.000,0.000,1.000",
                "police3,8.817,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.936,0.022,-0.934,0.065,0.351"
            ]
        },
        {
            "time": 2.265000104904175,
            "data": [
                "prisoner,4.498,0.000,1.517,0.000,0.000,0.000,1.000",
                "police3,8.801,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.022,-0.930,0.065,0.360"
            ]
        },
        {
            "time": 2.2820000648498537,
            "data": [
                "prisoner,4.498,0.000,1.525,0.000,0.000,0.000,1.000",
                "police3,8.788,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.023,-0.928,0.065,0.367"
            ]
        },
        {
            "time": 2.299999952316284,
            "data": [
                "prisoner,4.498,0.000,1.533,0.000,0.000,0.000,1.000",
                "police3,8.773,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.023,-0.924,0.064,0.376"
            ]
        },
        {
            "time": 2.316999912261963,
            "data": [
                "prisoner,4.498,0.000,1.542,0.000,0.000,0.000,1.000",
                "police3,8.757,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.024,-0.920,0.064,0.385"
            ]
        },
        {
            "time": 2.3359999656677248,
            "data": [
                "prisoner,4.498,0.000,1.551,0.000,0.000,0.000,1.000",
                "police3,8.742,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.024,-0.917,0.063,0.394"
            ]
        },
        {
            "time": 2.3469998836517336,
            "data": [
                "prisoner,4.498,0.000,1.561,0.000,0.000,0.000,1.000",
                "police3,8.725,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.025,-0.913,0.063,0.403"
            ]
        },
        {
            "time": 2.365000009536743,
            "data": [
                "prisoner,4.498,0.000,1.566,0.000,0.000,0.000,1.000",
                "police3,8.715,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.025,-0.910,0.062,0.409"
            ]
        },
        {
            "time": 2.380000114440918,
            "data": [
                "prisoner,4.498,0.000,1.575,0.000,0.000,0.000,1.000",
                "police3,8.699,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.025,-0.906,0.062,0.418"
            ]
        },
        {
            "time": 2.3970000743865969,
            "data": [
                "prisoner,4.498,0.000,1.583,0.000,0.000,0.000,1.000",
                "police3,8.685,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.026,-0.903,0.061,0.425"
            ]
        },
        {
            "time": 2.4140000343322756,
            "data": [
                "prisoner,4.498,0.000,1.591,0.000,0.000,0.000,1.000",
                "police3,8.670,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.026,-0.899,0.061,0.433"
            ]
        },
        {
            "time": 2.434999942779541,
            "data": [
                "prisoner,4.498,0.000,1.599,0.000,0.000,0.000,1.000",
                "police3,8.655,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.027,-0.895,0.060,0.441"
            ]
        },
        {
            "time": 2.447999954223633,
            "data": [
                "prisoner,4.498,0.000,1.610,0.000,0.000,0.000,1.000",
                "police3,8.636,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.027,-0.890,0.060,0.451"
            ]
        },
        {
            "time": 2.4630000591278078,
            "data": [
                "prisoner,4.498,0.000,1.616,0.000,0.000,0.000,1.000",
                "police3,8.625,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.028,-0.887,0.059,0.457"
            ]
        },
        {
            "time": 2.4820001125335695,
            "data": [
                "prisoner,4.498,0.000,1.623,0.000,0.000,0.000,1.000",
                "police3,8.611,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.028,-0.883,0.059,0.464"
            ]
        },
        {
            "time": 2.497999906539917,
            "data": [
                "prisoner,4.498,0.000,1.631,0.000,0.000,0.000,1.000",
                "police3,8.595,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.028,-0.879,0.058,0.472"
            ]
        },
        {
            "time": 2.515000104904175,
            "data": [
                "prisoner,4.498,0.000,1.639,0.000,0.000,0.000,1.000",
                "police3,8.580,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.029,-0.875,0.058,0.480"
            ]
        },
        {
            "time": 2.5350000858306886,
            "data": [
                "prisoner,4.498,0.000,1.646,0.000,0.000,0.000,1.000",
                "police3,8.565,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.029,-0.871,0.058,0.487"
            ]
        },
        {
            "time": 2.5490000247955324,
            "data": [
                "prisoner,4.498,0.000,1.655,0.000,0.000,0.000,1.000",
                "police3,8.547,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.029,-0.867,0.057,0.495"
            ]
        },
        {
            "time": 2.565000057220459,
            "data": [
                "prisoner,4.498,0.000,1.662,0.000,0.000,0.000,1.000",
                "police3,8.535,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.030,-0.863,0.057,0.501"
            ]
        },
        {
            "time": 2.5810000896453859,
            "data": [
                "prisoner,4.498,0.000,1.668,0.000,0.000,0.000,1.000",
                "police3,8.521,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.030,-0.860,0.056,0.507"
            ]
        },
        {
            "time": 2.5959999561309816,
            "data": [
                "prisoner,4.498,0.000,1.675,0.000,0.000,0.000,1.000",
                "police3,8.506,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.030,-0.856,0.056,0.513"
            ]
        },
        {
            "time": 2.61299991607666,
            "data": [
                "prisoner,4.498,0.000,1.681,0.000,0.000,0.000,1.000",
                "police3,8.493,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.031,-0.853,0.055,0.519"
            ]
        },
        {
            "time": 2.63100004196167,
            "data": [
                "prisoner,4.498,0.000,1.688,0.000,0.000,0.000,1.000",
                "police3,8.478,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.031,-0.849,0.055,0.525"
            ]
        },
        {
            "time": 2.6480000019073488,
            "data": [
                "prisoner,4.498,0.000,1.694,0.000,0.000,0.000,1.000",
                "police3,8.462,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.031,-0.845,0.055,0.531"
            ]
        },
        {
            "time": 2.6630001068115236,
            "data": [
                "prisoner,4.498,0.000,1.701,0.000,0.000,0.000,1.000",
                "police3,8.446,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.031,-0.841,0.054,0.537"
            ]
        },
        {
            "time": 2.680000066757202,
            "data": [
                "prisoner,4.498,0.000,1.707,0.000,0.000,0.000,1.000",
                "police3,8.433,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.032,-0.838,0.054,0.542"
            ]
        },
        {
            "time": 2.697000026702881,
            "data": [
                "prisoner,4.498,0.000,1.712,0.000,0.000,0.000,1.000",
                "police3,8.418,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.032,-0.834,0.053,0.548"
            ]
        },
        {
            "time": 2.7130000591278078,
            "data": [
                "prisoner,4.498,0.000,1.718,0.000,0.000,0.000,1.000",
                "police3,8.403,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.032,-0.831,0.053,0.553"
            ]
        },
        {
            "time": 2.7269999980926515,
            "data": [
                "prisoner,4.498,0.000,1.723,0.000,0.000,0.000,1.000",
                "police3,8.389,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.032,-0.828,0.053,0.557"
            ]
        },
        {
            "time": 2.743000030517578,
            "data": [
                "prisoner,4.498,0.000,1.728,0.000,0.000,0.000,1.000",
                "police3,8.376,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.032,-0.825,0.053,0.562"
            ]
        },
        {
            "time": 2.76200008392334,
            "data": [
                "prisoner,4.498,0.000,1.732,0.000,0.000,0.000,1.000",
                "police3,8.361,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.822,0.052,0.566"
            ]
        },
        {
            "time": 2.7780001163482668,
            "data": [
                "prisoner,4.498,0.000,1.738,0.000,0.000,0.000,1.000",
                "police3,8.345,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.819,0.052,0.571"
            ]
        },
        {
            "time": 2.7939999103546144,
            "data": [
                "prisoner,4.498,0.000,1.742,0.000,0.000,0.000,1.000",
                "police3,8.331,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.816,0.052,0.574"
            ]
        },
        {
            "time": 2.808000087738037,
            "data": [
                "prisoner,4.498,0.000,1.746,0.000,0.000,0.000,1.000",
                "police3,8.316,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.814,0.051,0.578"
            ]
        },
        {
            "time": 2.8259999752044679,
            "data": [
                "prisoner,4.498,0.000,1.749,0.000,0.000,0.000,1.000",
                "police3,8.304,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.812,0.051,0.581"
            ]
        },
        {
            "time": 2.8410000801086427,
            "data": [
                "prisoner,4.498,0.000,1.753,0.000,0.000,0.000,1.000",
                "police3,8.288,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.809,0.051,0.584"
            ]
        },
        {
            "time": 2.8580000400543215,
            "data": [
                "prisoner,4.498,0.000,1.756,0.000,0.000,0.000,1.000",
                "police3,8.275,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.808,0.051,0.587"
            ]
        },
        {
            "time": 2.875,
            "data": [
                "prisoner,4.498,0.000,1.759,0.000,0.000,0.000,1.000",
                "police3,8.259,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.805,0.050,0.590"
            ]
        },
        {
            "time": 2.8949999809265138,
            "data": [
                "prisoner,4.498,0.000,1.762,0.000,0.000,0.000,1.000",
                "police3,8.244,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.804,0.050,0.592"
            ]
        },
        {
            "time": 2.9049999713897707,
            "data": [
                "prisoner,4.498,0.000,1.765,0.000,0.000,0.000,1.000",
                "police3,8.226,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.802,0.050,0.595"
            ]
        },
        {
            "time": 2.921999931335449,
            "data": [
                "prisoner,4.498,0.000,1.766,0.000,0.000,0.000,1.000",
                "police3,8.217,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.801,0.050,0.596"
            ]
        },
        {
            "time": 2.937999963760376,
            "data": [
                "prisoner,4.498,0.000,1.768,0.000,0.000,0.000,1.000",
                "police3,8.202,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.800,0.050,0.597"
            ]
        },
        {
            "time": 2.9539999961853029,
            "data": [
                "prisoner,4.498,0.000,1.769,0.000,0.000,0.000,1.000",
                "police3,8.188,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.799,0.050,0.599"
            ]
        },
        {
            "time": 2.9679999351501467,
            "data": [
                "prisoner,4.498,0.000,1.771,0.000,0.000,0.000,1.000",
                "police3,8.174,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.798,0.050,0.599"
            ]
        },
        {
            "time": 2.986999988555908,
            "data": [
                "prisoner,4.498,0.000,1.771,0.000,0.000,0.000,1.000",
                "police3,8.161,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.798,0.050,0.600"
            ]
        },
        {
            "time": 3.00600004196167,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,0.000,0.000,1.000",
                "police3,8.144,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.797,0.050,0.601"
            ]
        },
        {
            "time": 3.0179998874664308,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,0.000,0.000,1.000",
                "police3,8.127,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.797,0.050,0.601"
            ]
        },
        {
            "time": 3.0320000648498537,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.003,0.000,1.000",
                "police3,8.116,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.797,0.050,0.600"
            ]
        },
        {
            "time": 3.0490000247955324,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.009,0.000,1.000",
                "police3,8.104,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.798,0.050,0.600"
            ]
        },
        {
            "time": 3.065000057220459,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.021,0.000,1.000",
                "police3,8.089,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.799,0.050,0.599"
            ]
        },
        {
            "time": 3.0799999237060549,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.036,0.000,0.999",
                "police3,8.075,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.800,0.050,0.598"
            ]
        },
        {
            "time": 3.1010000705718996,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.054,0.000,0.999",
                "police3,8.061,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.034,-0.801,0.050,0.596"
            ]
        },
        {
            "time": 3.114000082015991,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.083,0.000,0.997",
                "police3,8.042,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.803,0.050,0.593"
            ]
        },
        {
            "time": 3.130000114440918,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.103,0.000,0.995",
                "police3,8.031,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.804,0.050,0.591"
            ]
        },
        {
            "time": 3.1459999084472658,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.132,0.000,0.991",
                "police3,8.016,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.807,0.050,0.588"
            ]
        },
        {
            "time": 3.1610000133514406,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.162,0.000,0.987",
                "police3,8.002,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.809,0.050,0.585"
            ]
        },
        {
            "time": 3.177000045776367,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.190,0.000,0.982",
                "police3,7.989,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.033,-0.811,0.050,0.581"
            ]
        },
        {
            "time": 3.194999933242798,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.224,0.000,0.975",
                "police3,7.975,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.032,-0.814,0.050,0.577"
            ]
        },
        {
            "time": 3.2119998931884767,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.261,0.000,0.965",
                "police3,7.959,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.032,-0.818,0.050,0.573"
            ]
        },
        {
            "time": 3.2260000705718996,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.298,0.000,0.954",
                "police3,7.944,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.032,-0.821,0.051,0.568"
            ]
        },
        {
            "time": 3.243000030517578,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.331,0.000,0.944",
                "police3,7.931,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.031,-0.824,0.051,0.563"
            ]
        },
        {
            "time": 3.259999990463257,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.368,0.000,0.930",
                "police3,7.916,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.031,-0.828,0.051,0.557"
            ]
        },
        {
            "time": 3.2739999294281008,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.404,0.000,0.915",
                "police3,7.901,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.031,-0.832,0.051,0.551"
            ]
        },
        {
            "time": 3.2920000553131105,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.434,0.000,0.901",
                "police3,7.888,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.030,-0.836,0.051,0.546"
            ]
        },
        {
            "time": 3.308000087738037,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.470,0.000,0.882",
                "police3,7.873,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.030,-0.840,0.052,0.539"
            ]
        },
        {
            "time": 3.328000068664551,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.503,0.000,0.864",
                "police3,7.858,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.029,-0.845,0.052,0.532"
            ]
        },
        {
            "time": 3.3399999141693117,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.540,0.000,0.842",
                "police3,7.840,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.029,-0.850,0.052,0.523"
            ]
        },
        {
            "time": 3.3570001125335695,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.561,0.000,0.828",
                "police3,7.829,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.029,-0.854,0.052,0.518"
            ]
        },
        {
            "time": 3.375999927520752,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.589,0.000,0.808",
                "police3,7.814,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.028,-0.859,0.053,0.509"
            ]
        },
        {
            "time": 3.3889999389648439,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.616,0.000,0.787",
                "police3,7.797,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.027,-0.864,0.053,0.500"
            ]
        },
        {
            "time": 3.4059998989105226,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.634,0.000,0.773",
                "police3,7.786,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.142,0.301,1.937,0.027,-0.868,0.053,0.493"
            ]
        },
        {
            "time": 3.424999952316284,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.654,0.000,0.757",
                "police3,7.771,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.026,-0.873,0.053,0.484"
            ]
        },
        {
            "time": 3.441999912261963,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.672,0.000,0.740",
                "police3,7.754,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.026,-0.879,0.054,0.473"
            ]
        },
        {
            "time": 3.4600000381469728,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.686,0.000,0.727",
                "police3,7.738,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.025,-0.884,0.054,0.463"
            ]
        },
        {
            "time": 3.4760000705718996,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.697,0.000,0.717",
                "police3,7.722,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.024,-0.890,0.054,0.452"
            ]
        },
        {
            "time": 3.49399995803833,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.703,0.000,0.711",
                "police3,7.708,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.024,-0.895,0.054,0.442"
            ]
        },
        {
            "time": 3.509000062942505,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.692,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.023,-0.901,0.055,0.430"
            ]
        },
        {
            "time": 3.5280001163482668,
            "data": [
                "prisoner,4.498,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.679,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.023,-0.906,0.055,0.420"
            ]
        },
        {
            "time": 3.546999931335449,
            "data": [
                "prisoner,4.497,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.661,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.022,-0.912,0.055,0.407"
            ]
        },
        {
            "time": 3.566999912261963,
            "data": [
                "prisoner,4.495,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.645,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.021,-0.917,0.056,0.394"
            ]
        },
        {
            "time": 3.5810000896453859,
            "data": [
                "prisoner,4.492,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.627,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.020,-0.923,0.056,0.379"
            ]
        },
        {
            "time": 3.5959999561309816,
            "data": [
                "prisoner,4.489,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.614,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.019,-0.928,0.056,0.368"
            ]
        },
        {
            "time": 3.61299991607666,
            "data": [
                "prisoner,4.486,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.601,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.019,-0.932,0.056,0.357"
            ]
        },
        {
            "time": 3.631999969482422,
            "data": [
                "prisoner,4.481,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.586,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.018,-0.937,0.057,0.344"
            ]
        },
        {
            "time": 3.6519999504089357,
            "data": [
                "prisoner,4.475,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.569,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.017,-0.942,0.057,0.329"
            ]
        },
        {
            "time": 3.6679999828338625,
            "data": [
                "prisoner,4.469,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.551,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.016,-0.948,0.057,0.313"
            ]
        },
        {
            "time": 3.680999994277954,
            "data": [
                "prisoner,4.462,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.537,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.015,-0.952,0.057,0.300"
            ]
        },
        {
            "time": 3.6989998817443849,
            "data": [
                "prisoner,4.457,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.525,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.015,-0.956,0.057,0.289"
            ]
        },
        {
            "time": 3.7149999141693117,
            "data": [
                "prisoner,4.449,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.510,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.014,-0.960,0.058,0.274"
            ]
        },
        {
            "time": 3.7300000190734865,
            "data": [
                "prisoner,4.442,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.495,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.143,0.301,1.937,0.013,-0.964,0.058,0.260"
            ]
        },
        {
            "time": 3.746000051498413,
            "data": [
                "prisoner,4.434,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.482,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.012,-0.967,0.058,0.246"
            ]
        },
        {
            "time": 3.76200008392334,
            "data": [
                "prisoner,4.426,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.467,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.011,-0.971,0.058,0.232"
            ]
        },
        {
            "time": 3.7769999504089357,
            "data": [
                "prisoner,4.417,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.453,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.010,-0.974,0.058,0.218"
            ]
        },
        {
            "time": 3.7899999618530275,
            "data": [
                "prisoner,4.409,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.439,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.009,-0.977,0.058,0.204"
            ]
        },
        {
            "time": 3.805000066757202,
            "data": [
                "prisoner,4.402,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.428,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.009,-0.979,0.059,0.193"
            ]
        },
        {
            "time": 3.821000099182129,
            "data": [
                "prisoner,4.393,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.415,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.008,-0.982,0.059,0.179"
            ]
        },
        {
            "time": 3.8359999656677248,
            "data": [
                "prisoner,4.383,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.400,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.007,-0.985,0.059,0.163"
            ]
        },
        {
            "time": 3.8480000495910646,
            "data": [
                "prisoner,4.373,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.387,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.006,-0.987,0.059,0.150"
            ]
        },
        {
            "time": 3.867000102996826,
            "data": [
                "prisoner,4.365,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.376,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.005,-0.989,0.059,0.138"
            ]
        },
        {
            "time": 3.877000093460083,
            "data": [
                "prisoner,4.353,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.359,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.004,-0.991,0.059,0.120"
            ]
        },
        {
            "time": 3.8910000324249269,
            "data": [
                "prisoner,4.346,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.350,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.004,-0.992,0.059,0.110"
            ]
        },
        {
            "time": 3.9049999713897707,
            "data": [
                "prisoner,4.337,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.338,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.003,-0.994,0.059,0.097"
            ]
        },
        {
            "time": 3.9189999103546144,
            "data": [
                "prisoner,4.328,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.326,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.002,-0.995,0.059,0.084"
            ]
        },
        {
            "time": 3.933000087738037,
            "data": [
                "prisoner,4.318,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.313,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.001,-0.996,0.059,0.070"
            ]
        },
        {
            "time": 3.946000099182129,
            "data": [
                "prisoner,4.309,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.301,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.001,-0.997,0.059,0.057"
            ]
        },
        {
            "time": 3.9600000381469728,
            "data": [
                "prisoner,4.299,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.289,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,0.000,-0.997,0.059,0.044"
            ]
        },
        {
            "time": 3.9760000705718996,
            "data": [
                "prisoner,4.289,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.276,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,-0.001,-0.998,0.059,0.030"
            ]
        },
        {
            "time": 3.990000009536743,
            "data": [
                "prisoner,4.278,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.262,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,-0.002,-0.998,0.059,0.014"
            ]
        },
        {
            "time": 4.001999855041504,
            "data": [
                "prisoner,4.268,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.250,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,-0.003,-0.998,0.059,0.000"
            ]
        },
        {
            "time": 4.013000011444092,
            "data": [
                "prisoner,4.260,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.239,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.144,0.301,1.937,-0.003,-0.998,0.059,-0.011"
            ]
        },
        {
            "time": 4.026000022888184,
            "data": [
                "prisoner,4.251,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.229,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.937,-0.004,-0.998,0.059,-0.022"
            ]
        },
        {
            "time": 4.039000034332275,
            "data": [
                "prisoner,4.242,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.218,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.937,-0.005,-0.998,0.059,-0.035"
            ]
        },
        {
            "time": 4.052000045776367,
            "data": [
                "prisoner,4.233,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.206,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.937,-0.006,-0.997,0.059,-0.048"
            ]
        },
        {
            "time": 4.067999839782715,
            "data": [
                "prisoner,4.224,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.194,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.006,-0.996,0.059,-0.061"
            ]
        },
        {
            "time": 4.084000110626221,
            "data": [
                "prisoner,4.213,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.180,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.007,-0.995,0.059,-0.076"
            ]
        },
        {
            "time": 4.093999862670898,
            "data": [
                "prisoner,4.201,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.166,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.008,-0.994,0.058,-0.092"
            ]
        },
        {
            "time": 4.107999801635742,
            "data": [
                "prisoner,4.195,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.157,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.009,-0.993,0.058,-0.101"
            ]
        },
        {
            "time": 4.11899995803833,
            "data": [
                "prisoner,4.185,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.145,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.009,-0.992,0.058,-0.114"
            ]
        },
        {
            "time": 4.133999824523926,
            "data": [
                "prisoner,4.178,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.135,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.010,-0.990,0.058,-0.125"
            ]
        },
        {
            "time": 4.144999980926514,
            "data": [
                "prisoner,4.168,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.121,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.011,-0.988,0.058,-0.139"
            ]
        },
        {
            "time": 4.159999847412109,
            "data": [
                "prisoner,4.160,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.111,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.012,-0.987,0.058,-0.150"
            ]
        },
        {
            "time": 4.171999931335449,
            "data": [
                "prisoner,4.151,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.098,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.012,-0.985,0.058,-0.165"
            ]
        },
        {
            "time": 4.190000057220459,
            "data": [
                "prisoner,4.143,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.087,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.013,-0.983,0.058,-0.176"
            ]
        },
        {
            "time": 4.203000068664551,
            "data": [
                "prisoner,4.132,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.071,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.014,-0.979,0.057,-0.193"
            ]
        },
        {
            "time": 4.210999965667725,
            "data": [
                "prisoner,4.125,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.060,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.015,-0.977,0.057,-0.204"
            ]
        },
        {
            "time": 4.2270002365112309,
            "data": [
                "prisoner,4.120,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.052,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.015,-0.975,0.057,-0.212"
            ]
        },
        {
            "time": 4.23799991607666,
            "data": [
                "prisoner,4.111,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.039,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.016,-0.972,0.057,-0.226"
            ]
        },
        {
            "time": 4.250999927520752,
            "data": [
                "prisoner,4.104,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.029,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.017,-0.970,0.057,-0.236"
            ]
        },
        {
            "time": 4.265999794006348,
            "data": [
                "prisoner,4.097,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.017,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.017,-0.967,0.056,-0.248"
            ]
        },
        {
            "time": 4.2789998054504398,
            "data": [
                "prisoner,4.090,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,7.004,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.018,-0.964,0.056,-0.261"
            ]
        },
        {
            "time": 4.296000003814697,
            "data": [
                "prisoner,4.083,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.992,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.145,0.301,1.938,-0.019,-0.960,0.056,-0.273"
            ]
        },
        {
            "time": 4.306000232696533,
            "data": [
                "prisoner,4.075,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.977,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.020,-0.956,0.056,-0.287"
            ]
        },
        {
            "time": 4.320000171661377,
            "data": [
                "prisoner,4.071,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.968,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.020,-0.954,0.055,-0.295"
            ]
        },
        {
            "time": 4.330999851226807,
            "data": [
                "prisoner,4.064,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.956,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.021,-0.950,0.055,-0.307"
            ]
        },
        {
            "time": 4.3480000495910648,
            "data": [
                "prisoner,4.060,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.945,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.021,-0.947,0.055,-0.317"
            ]
        },
        {
            "time": 4.361999988555908,
            "data": [
                "prisoner,4.053,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.931,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.022,-0.942,0.055,-0.330"
            ]
        },
        {
            "time": 4.374000072479248,
            "data": [
                "prisoner,4.048,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.918,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.023,-0.938,0.054,-0.342"
            ]
        },
        {
            "time": 4.389999866485596,
            "data": [
                "prisoner,4.044,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.907,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.023,-0.934,0.054,-0.351"
            ]
        },
        {
            "time": 4.40500020980835,
            "data": [
                "prisoner,4.040,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.893,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.024,-0.929,0.054,-0.364"
            ]
        },
        {
            "time": 4.416999816894531,
            "data": [
                "prisoner,4.036,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.880,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.025,-0.925,0.054,-0.375"
            ]
        },
        {
            "time": 4.432000160217285,
            "data": [
                "prisoner,4.033,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.869,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.025,-0.921,0.053,-0.385"
            ]
        },
        {
            "time": 4.446000099182129,
            "data": [
                "prisoner,4.030,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.856,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.026,-0.917,0.053,-0.396"
            ]
        },
        {
            "time": 4.460000038146973,
            "data": [
                "prisoner,4.028,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.843,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.026,-0.912,0.053,-0.406"
            ]
        },
        {
            "time": 4.473999977111816,
            "data": [
                "prisoner,4.026,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.830,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.027,-0.907,0.052,-0.416"
            ]
        },
        {
            "time": 4.488999843597412,
            "data": [
                "prisoner,4.025,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.818,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.028,-0.903,0.052,-0.426"
            ]
        },
        {
            "time": 4.502999782562256,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.805,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.028,-0.898,0.052,-0.435"
            ]
        },
        {
            "time": 4.517000198364258,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.707,0.000,0.707",
                "police3,6.792,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.029,-0.894,0.051,-0.445"
            ]
        },
        {
            "time": 4.53000020980835,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.709,0.000,0.705",
                "police3,6.780,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.029,-0.889,0.051,-0.454"
            ]
        },
        {
            "time": 4.544000148773193,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.713,0.000,0.701",
                "police3,6.768,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.030,-0.885,0.051,-0.463"
            ]
        },
        {
            "time": 4.558000087738037,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.719,0.000,0.695",
                "police3,6.756,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.030,-0.880,0.051,-0.471"
            ]
        },
        {
            "time": 4.573999881744385,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.727,0.000,0.686",
                "police3,6.743,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.031,-0.876,0.050,-0.479"
            ]
        },
        {
            "time": 4.5879998207092289,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.739,0.000,0.674",
                "police3,6.729,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.031,-0.871,0.050,-0.489"
            ]
        },
        {
            "time": 4.599999904632568,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.751,0.000,0.660",
                "police3,6.716,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.032,-0.866,0.050,-0.497"
            ]
        },
        {
            "time": 4.614999771118164,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.763,0.000,0.647",
                "police3,6.705,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.032,-0.862,0.049,-0.503"
            ]
        },
        {
            "time": 4.633999824523926,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.777,0.000,0.629",
                "police3,6.692,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.146,0.301,1.938,-0.032,-0.857,0.049,-0.511"
            ]
        },
        {
            "time": 4.644999980926514,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.798,0.000,0.602",
                "police3,6.675,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.033,-0.851,0.049,-0.521"
            ]
        },
        {
            "time": 4.6579999923706059,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.810,0.000,0.586",
                "police3,6.666,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.033,-0.848,0.049,-0.526"
            ]
        },
        {
            "time": 4.671999931335449,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.826,0.000,0.564",
                "police3,6.654,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.034,-0.844,0.048,-0.533"
            ]
        },
        {
            "time": 4.686999797821045,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.842,0.000,0.540",
                "police3,6.641,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.034,-0.840,0.048,-0.539"
            ]
        },
        {
            "time": 4.703000068664551,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.858,0.000,0.513",
                "police3,6.628,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.034,-0.836,0.048,-0.546"
            ]
        },
        {
            "time": 4.7170000076293949,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.876,0.000,0.482",
                "police3,6.614,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.035,-0.831,0.047,-0.552"
            ]
        },
        {
            "time": 4.730999946594238,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.892,0.000,0.453",
                "police3,6.601,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.035,-0.828,0.047,-0.558"
            ]
        },
        {
            "time": 4.749000072479248,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.906,0.000,0.423",
                "police3,6.589,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.035,-0.824,0.047,-0.564"
            ]
        },
        {
            "time": 4.757999897003174,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.923,0.000,0.384",
                "police3,6.573,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.036,-0.819,0.047,-0.570"
            ]
        },
        {
            "time": 4.77400016784668,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.931,0.000,0.366",
                "police3,6.565,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.036,-0.817,0.047,-0.573"
            ]
        },
        {
            "time": 4.785999774932861,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.944,0.000,0.331",
                "police3,6.551,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.036,-0.814,0.046,-0.578"
            ]
        },
        {
            "time": 4.802000045776367,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.953,0.000,0.304",
                "police3,6.540,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.037,-0.811,0.046,-0.582"
            ]
        },
        {
            "time": 4.814000129699707,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.963,0.000,0.269",
                "police3,6.526,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.037,-0.808,0.046,-0.587"
            ]
        },
        {
            "time": 4.829999923706055,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.970,0.000,0.243",
                "police3,6.515,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.037,-0.805,0.046,-0.590"
            ]
        },
        {
            "time": 4.843999862670898,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.978,0.000,0.209",
                "police3,6.501,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.037,-0.802,0.046,-0.594"
            ]
        },
        {
            "time": 4.859000205993652,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.984,0.000,0.181",
                "police3,6.488,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.037,-0.800,0.045,-0.598"
            ]
        },
        {
            "time": 4.872000217437744,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.988,0.000,0.151",
                "police3,6.475,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.038,-0.797,0.045,-0.601"
            ]
        },
        {
            "time": 4.883999824523926,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.992,0.000,0.128",
                "police3,6.463,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.038,-0.795,0.045,-0.604"
            ]
        },
        {
            "time": 4.900000095367432,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.994,0.000,0.107",
                "police3,6.452,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.038,-0.794,0.045,-0.606"
            ]
        },
        {
            "time": 4.9120001792907719,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.997,0.000,0.082",
                "police3,6.438,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.038,-0.792,0.045,-0.608"
            ]
        },
        {
            "time": 4.926000118255615,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.998,0.000,0.064",
                "police3,6.427,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.038,-0.790,0.045,-0.610"
            ]
        },
        {
            "time": 4.941999912261963,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-0.999,0.000,0.046",
                "police3,6.415,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.038,-0.789,0.045,-0.612"
            ]
        },
        {
            "time": 4.955999851226807,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-1.000,0.000,0.029",
                "police3,6.401,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.038,-0.788,0.045,-0.613"
            ]
        },
        {
            "time": 4.9720001220703129,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-1.000,0.000,0.017",
                "police3,6.388,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.038,-0.787,0.045,-0.614"
            ]
        },
        {
            "time": 4.985000133514404,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-1.000,0.000,0.007",
                "police3,6.374,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.038,-0.786,0.045,-0.615"
            ]
        },
        {
            "time": 4.997000217437744,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-1.000,0.000,0.002",
                "police3,6.363,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.038,-0.786,0.045,-0.616"
            ]
        },
        {
            "time": 5.011000156402588,
            "data": [
                "prisoner,4.024,0.000,1.772,0.000,-1.000,0.000,0.000",
                "police3,6.352,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM,4.838,0.000,0.449,0.000,0.000,0.000,1.000",
                "observationCamera,5.147,0.301,1.938,-0.038,-0.786,0.045,-0.616"
            ]
        }
    ]
};
